import pull from "lodash-es/pull";
import { useEffect } from "react";

import authStore, { type LoginRequirement } from "../../stores/auth/authStore";
import { logger } from "../logger";

const useLoginRequired = (feature: LoginRequirement) => {
   useEffect(() => {
      if (feature === "NOT_REQUIRED") {
         return;
      }

      logger.log("auth", `LOGIN REQUIRED: Added ${feature}`);
      authStore.currentlyRequiresLogin.push(feature);

      return () => {
         logger.log("auth", `LOGIN REQUIRED: Removed ${feature}`);
         pull(authStore.currentlyRequiresLogin, feature);
      };
   }, [feature]);
};

export default useLoginRequired;
